import { breakpoints } from './gridLayoutConfigurations';

export { breakpoints } from './gridLayoutConfigurations';

// Pre-built media query strings for styled-components template literals
// Usage: ${media.down.xs} { font-size: 14px; }
export const media = {
  down: {
    xxs: `@media (max-width: ${breakpoints.xs - 1}px)`,   // <480px  — mobile portrait
    xs:  `@media (max-width: ${breakpoints.sm - 1}px)`,    // <768px  — mobile
    sm:  `@media (max-width: ${breakpoints.md - 1}px)`,    // <996px  — small tablet
    md:  `@media (max-width: ${breakpoints.lg - 1}px)`,    // <1200px — tablet
    lg:  `@media (max-width: ${breakpoints.xl - 1}px)`,    // <1920px — desktop
    xl:  `@media (max-width: ${breakpoints.xxl - 1}px)`,   // <2560px — large desktop
  },
  up: {
    xs:  `@media (min-width: ${breakpoints.xs}px)`,        // >=480px
    sm:  `@media (min-width: ${breakpoints.sm}px)`,        // >=768px
    md:  `@media (min-width: ${breakpoints.md}px)`,        // >=996px
    lg:  `@media (min-width: ${breakpoints.lg}px)`,        // >=1200px
    xl:  `@media (min-width: ${breakpoints.xl}px)`,        // >=1920px
    xxl: `@media (min-width: ${breakpoints.xxl}px)`,       // >=2560px
  },
  between: (lower: keyof typeof breakpoints, upper: keyof typeof breakpoints) =>
    `@media (min-width: ${breakpoints[lower]}px) and (max-width: ${breakpoints[upper] - 1}px)`,
};
